import { Loader } from "@googlemaps/js-api-loader";
import { view } from "../../../views/mapView/MapView";
import Graphic from "@arcgis/core/Graphic"; //
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as projection from "@arcgis/core/geometry/projection";
import Point from "@arcgis/core/geometry/Point";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
//import { project } from "@arcgis/core/geometry/projection";
import { googleAPIKey } from "../../../config";

export const callback = (e, visible, panorama) => {
  if (visible) {
    projection.load().then(() => {
      let projectedPoints = projection.project(
        [e.mapPoint],
        new SpatialReference({ wkid: 4326 })
      );
      let mapPoint = {
        lat: projectedPoints[0].y,
        lng: projectedPoints[0].x,
      };
      panorama.setPosition(mapPoint);
      panorama.setVisible(true);
    });
  }
};

export const removeGoogleLayer = (view) => {
  if (view.ready) {
    let layr = view.map.allLayers.filter((layer) => {
      return layer.id === "googlemap_graphiclyr";
    }) as any;
    if (layr.length) {
      layr.getItemAt(0).graphics.removeAll();
    }
  }
};

export const initialize = (element, setView, view) => {
  //view.when(() => {
    let googleGraphicsLayer;
    let outSR = new SpatialReference({ wkid: view.spatialReference.wkid });
    let inSR = new SpatialReference({ wkid: 4326 });
    var headingsymbol = {
      type: "picture-marker", // autocasts as new PictureMarkerSymbol()
      url: `${process.env.PUBLIC_URL}/idk.png`,
      width: "50px",
      height: "50px",
      angle: 0,
    };
    googleGraphicsLayer = new GraphicsLayer({
      id: "googlemap_graphiclyr",
      title: "Google Layer",
      listMode: "hide",
    });
    let gmap;
    const fenway = { lat: 33.64207, lng: -117.950164 };
    const loader = new Loader({
      apiKey: googleAPIKey,
    });

    loader.load().then((google) => {
      gmap = new google.maps.Map(element, {
        center: fenway,
        zoom: 10,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
      });

      let panorama = gmap.getStreetView();
      panorama.setOptions({
        addressControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
      });
      panorama.addListener("pov_changed", () => {
        headingsymbol.angle = parseFloat(panorama.getPov().heading);
        let gposition = panorama.getPosition() + "";
        gposition = gposition.replace("(", "");
        gposition = gposition.replace(")", "");

        let newpoint = new Point({
          x: parseFloat(gposition.split(",")[1]),
          y: parseFloat(gposition.split(",")[0]),
          spatialReference: inSR,
        });

        projection.load().then(function () {
          let proj = projection.project(newpoint, outSR);
          googleGraphicsLayer.graphics.removeAll();

          let pointGraphic: any = new Graphic({
            geometry: proj as any,
            symbol: headingsymbol as any,
          });
          view.center = newpoint;
          googleGraphicsLayer.graphics.add(pointGraphic);
        });
      });

      setView(panorama);
      // view.when((view) => {
      view.map.add(googleGraphicsLayer, view.map.allLayers.length);
    });
  //});
};
